<template>
  <div>
    <v-row>
      <v-spacer></v-spacer>
      <v-col class="text-right">
        <v-dialog v-model="dialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">Create New User Roles Permission</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" align="center" justify="center">
                    <v-btn-toggle
                      v-model="text"
                      tile
                      color="deep-purple accent-3"
                      group
                      class="text-center"
                      rounded
                    >
                      <v-btn value="Details"> Details </v-btn>
                      <v-btn value="Permissions"> Permissions </v-btn>
                    </v-btn-toggle>
                  </v-col>
                </v-row>
                <v-row v-if="text == 'Details'">
                  <v-col cols="12">
                    <v-text-field
                      label="Name*"
                      v-model="name"
                      required
                      hint="Make sure it's easy to remember"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      label="Details*"
                      v-model="details"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-else-if="text == 'Permissions'">
                  <v-col cols="6"> Assigned </v-col>
                  <v-col cols="6"> Not Assigned </v-col>
                  <v-col cols="6" class="permission-box">
                    <ul
                      v-for="permission in getGroupAssignedPermissions"
                      :key="permission.id"
                    >
                      <li @dblclick="remove(permission)">
                        {{ permission.name }}
                      </li>
                    </ul>
                  </v-col>
                  <v-col cols="6" class="permission-box">
                    <ul
                      v-for="permission in getGroupUnassignedPermissions"
                      :key="permission.id"
                    >
                      <li @dblclick="add(permission)">{{ permission.name }}</li>
                    </ul>
                  </v-col>
                  <v-col cols="6"></v-col>
                  <v-col cols="6" class="outline text-right"
                    ><span
                      class="outline primary--text"
                      style="cursor: pointer"
                      @click="selectAllPermissions"
                      >Select All</span
                    ></v-col
                  >
                </v-row>
                <v-row>
                  <v-col cols="12" v-if="errorMessage">
                    <h3 class="text-center red--text">{{ errorMessage }}</h3>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close()">Close</v-btn>
              <v-btn color="blue darken-1" text @click="saveNewPermissionGroup"
                :disabled="disableSave">Save</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <loading-overlay v-if="loading"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// import Swal from "sweetalert2";
import LoadingOverlay from "./common/LoadingOverlay.vue";

export default {
  name: "PermissionGroupModal",
  components: {
    LoadingOverlay
  },
  props: {
    dialog: Boolean,
    editPermissionGroup: Object,
  },
  data() {
    return {
      disableSave: false,
      loading: false,
      name: "",
      details: "",
      text: "Details",
      errorMessage: null,
      updateItem: null,
    };
  },
  methods: {
    ...mapActions([
      "createPermissionGroup",
      "fetchPermissionGroups",
      "fetchGroupUnassignedPermissions",
      "addGroupPermission",
      "removeGroupPermission",
      "updatePermissionGroup",
      "selectAllPermissions",
    ]),
    async saveNewPermissionGroup() {
      // this.validate();
      this.disableSave = true;
      this.loading = true;
      let save;
      let body = {
        name: this.name,
        details: this.details,
      };

      if (this.updateItem) {
        body = Object.assign(body, { permission_group_id: this.updateItem.id });
        save = await this.updatePermissionGroup(body);
      } else {
        save = await this.createPermissionGroup(body);
      }
      if (save.error) {
        this.disableSave = false
        this.loading = false
        if(this.name.length < 4)
          this.errorMessage = "Name must be 4 characters long"
        else
          this.errorMessage = ""
      } else if (save) {
        this.disableSave = false
        this.loading = false;
        this.name = "";
        this.details = "";
        this.text = "Details";
        this.updateItem = null;
        this.$emit("closeDialog", true);
      }
    },
    remove(item) {
      this.removeGroupPermission(item);
    },
    add(item) {
      this.addGroupPermission(item);
    },
    close() {
      this.disableSave = false
      this.$emit("closeDialog", false);
    },
  },
  watch: {
    dialog: function () {
      if (!this.editPermissionGroup) {
        this.fetchGroupUnassignedPermissions({ id: -1, permissions: [] });
      }
    },
    editPermissionGroup: function () {
      if (this.editPermissionGroup) {
        this.updateItem = this.editPermissionGroup;
        this.name = this.editPermissionGroup.name;
        this.details = this.editPermissionGroup.details;
        this.fetchGroupUnassignedPermissions({
          id: this.editPermissionGroup.id,
          permissions: this.editPermissionGroup.permissions,
        });
      } else {
        this.updateItem = null;
      }
    },
  },
  computed: {
    ...mapGetters([
      "allPermissionGroups",
      "getGroupUnassignedPermissions",
      "getGroupAssignedPermissions",
    ]),
  },
};
</script>

<style scoped>
.permission-box {
  overflow: auto;
  overflow-x: hidden;
  height: 300px;
  border-style: solid;
  border-width: thin;
  border-color: #d1d1d1;
}

ul {
  padding: 0px;
  margin-top: 0px;
}

li {
  list-style: none;
  border-bottom: solid;
  border-width: thin;
  padding-bottom: 6px;
  padding-top: 6px;
  cursor: pointer;
}

li:hover {
  background-color: rgb(230, 230, 230);
}
</style>